import React from 'react';
import { Button, Modal } from 'antd';
import { RichTextViewer } from '../../components/RichTextEditor';

interface ContentModalProps {
	title: string;
	/** Chips identifying the entry, shown above the content. */
	meta?: React.ReactNode;
	html: string | null;
	emptyText: string;
	open: boolean;
	onClose: () => void;
	/** Runs once the dialog has faded out. See {@link useContentViewer}. */
	afterClose?: () => void;
}

/**
 * Read-only view of what someone wrote on a review, an issue or a feedback
 * entry. The table layout trades the preview for a dense row, so this is the
 * only way to reach the content from there.
 */
const ContentModal: React.FC<ContentModalProps> = ({
	title,
	meta,
	html,
	emptyText,
	open,
	onClose,
	afterClose,
}) => (
	<Modal
		className="cam-modal"
		title={title}
		open={open}
		centered
		onCancel={onClose}
		afterClose={afterClose}
		footer={<Button onClick={onClose}>Close</Button>}
		width={780}
		destroyOnClose
	>
		{meta && <div className="cam-content-modal__meta">{meta}</div>}
		<RichTextViewer
			html={html}
			emptyText={emptyText}
			className="cam-entry__body"
		/>
	</Modal>
);

export default ContentModal;
